module.exports = __webpack_public_path__ + "static/media/collaborate.de97e618.svg";